import { useQuery } from 'react-query';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import i18n, { FALLBACK_LOCALE } from 'providers/i18n/i18n';
import { getModels } from 'services/ModelService';
import { IRootReducerState } from 'store/store';
import { useSelector } from 'react-redux';

export const useGetModels = (
  page: number,
  perPage: number,
  searchBy: string,
  categoryId: number | null,
  favorites: boolean,
  companyId: number | undefined,
  companySellerId?: number | undefined
) => {
  const activeCompanyId = useSelector(
    (state: IRootReducerState) => state.userInfo.company?.id
  );
  return useQuery({
    queryKey: [
      ReactQueryKeys.GET_MODELS,
      page,
      perPage,
      searchBy,
      categoryId,
      favorites,
      companyId,
      companySellerId,
      i18n.resolvedLanguage || FALLBACK_LOCALE,
      activeCompanyId,
    ],
    queryFn: () => {
      return getModels(
        page,
        perPage,
        searchBy,
        categoryId,
        favorites,
        i18n.resolvedLanguage || FALLBACK_LOCALE,
        companyId,
        companySellerId
      );
    },
    enabled: !!companyId || !!companySellerId,
  });
};
